function error() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./error.html'),
    scope: {},
    controller: 'ErrorController',
    controllerAs: 'vm',
    bindToController: {
      backRoute: '@?',
      fullPage: '@?',
      type: '@?'
    }
  };
}

function ErrorController($state, gettextCatalog) {
  'ngInject';

  var vm = this;

  var _messages = {
    'generic': {
      header: gettextCatalog.getString('no-data.panel.header')
    },
    'generic.page': {
      body: gettextCatalog.getString('no-data.page.body')
    },
    'generic.panel': {
      body: gettextCatalog.getString('no-data.panel.body')
    },
    'permissions': {
      header: gettextCatalog.getString('no-data.permissions.header'),
      body: gettextCatalog.getString('no-data.permissions.body')
    },
    'no-production-data-apps': {
      header: gettextCatalog.getString('no-data.no-production-data.header')
    },
    'no-production-data-statistics': {
      header: gettextCatalog.getString('no-data.no-production-data.header'),
      body: gettextCatalog.getString('no-data.no-production-data.body')
    },
    'no-apps': {
      header: gettextCatalog.getString('no-data.no-apps.header'),
      body: gettextCatalog.getString('no-data.no-apps.body', {
        url: $state.href('apps.new-app')
      })
    },
    'statistics': {
      body: gettextCatalog.getString('no-data.statistics.body')
    },
    'statistics.apptrace': {
      header: gettextCatalog.getString('no-data.apptrace.header')
    },
    'statistics.apptrace-not-synced': {
      header: gettextCatalog.getString('no-data.apptrace.header'),
      body: gettextCatalog.getString('no-data.apptrace.not-synced.body')
    },
    'statistics.cost': {
      header: gettextCatalog.getString('no-data.cost.header')
    },
    'statistics.overview': {
      header: gettextCatalog.getString('no-data.overview.header')
    },
    'statistics.fraud-prevention': {
      header: gettextCatalog.getString('no-data.fraud-prevention.header')
    },
    'statistics.cohorts': {
      header: gettextCatalog.getString('no-data.cohorts.header')
    }
  };

  vm.backRoute = vm.backRoute || 'apps';
  vm.fullPage = !!vm.fullPage;
  vm.message = _selectMessage(vm.type);

  /**
   * @param {String} msg message reference with pattern "base.extended"
   * @returns {Object}
   * @private
   */
  function _selectMessage(msg) {

    // This is used for adding backward compatibility with 'page' and 'panel'
    // once we replace those from the consumers side we can get rid of this line and function
    msg = _getNewMessage(msg);

    if (!msg || !_messages[msg]) {
      return _selectMessage('generic.panel');
    }

    const [ base ] = msg.split('.');

    return {
      ..._messages[base],
      ..._messages[msg]
    };

  }

  /**
   * @param {String} msg old message reference
   * @returns {String} new message reference
   * @private
   */
  function _getNewMessage(msg) {

    switch (msg) {
    case 'panel':
      return 'generic.panel';
    case 'page':
      return 'generic.page';
    default:
      return msg;
    }

  }
}

export { ErrorController, error };
